(function() {
  var bar = document.createElement('div');
  bar.id = 'glerap-announcement';
  bar.style.cssText = 'background:#000;color:#fff;text-align:center;padding:12px 40px;position:relative;font-size:14px;';
  bar.innerHTML = 'FREE SHIPPING ON ORDERS $49+ | Use code BOGO at checkout';
  
  var observer = new MutationObserver(function(mutations) {
    var header = document.querySelector('header');
    if (header && !document.getElementById('glerap-announcement')) {
      header.after(bar);
      observer.disconnect();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
